(() => {
  document.addEventListener('click', (event) => {
    const proxy = event.target.closest('[data-vf-quick-proxy]');
    if (!proxy) return;

    event.preventDefault();
    event.stopPropagation();

    const targetId = proxy.dataset.vfQuickProxy;
    const target = targetId ? document.getElementById(targetId) : null;
    if (!target || target.disabled) return;

    target.click();
  });
})();